<template>
  <SoPage>
    <SoAlert type="error" title="Unauthorised">
      It looks like you're unauthorised to see this page. If you feel like you
      should have the permissions to see this page, please raise a ticket with
      IT
      <SoLink
        text="here"
        href="https://soenergy.atlassian.net/servicedesk/customer/portal/2/group/4"
      />.
    </SoAlert>
  </SoPage>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPage from "@/components/templates/SoPage.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoLink from "@/components/SoLink.vue"

  export default defineComponent({
    name: "NotAuthorised",
    components: { SoPage, SoAlert, SoLink },
  })
</script>
